<template>
  <div
    v-if="notices.length > 0"
    class="flex flex-col gap-5 md:gap-7.5 xl:gap-10 2xl:gap-11.25"
  >
    <SectionTitle v-if="title" :title="title" class="no-underline!" />

    <div class="flex flex-col">
      <div class="flex flex-col">
        <NoticeRow
          v-for="notice in initialNotices"
          :key="notice.id"
          :notice="notice"
        />
      </div>

      <div
        v-if="animatedNotices.length > 0"
        class="grid transition-all duration-500 ease-in-out"
        :class="
          isExpanded
            ? 'grid-rows-[1fr] opacity-100'
            : 'grid-rows-[0fr] opacity-0'
        "
      >
        <div class="flex flex-col overflow-hidden">
          <NoticeRow
            v-for="notice in animatedNotices"
            :key="notice.id"
            :notice="notice"
            class="first:border-t-0!"
          />
        </div>
      </div>
    </div>

    <ShowMoreButton
      v-if="notices.length > 5 && !disableCollapse"
      v-model:is-expanded="isExpanded"
      type="border"
      class="mt-2.5"
      button-color="dark"
    />
  </div>
</template>

<script setup lang="ts">
import type { Notice } from '~/types'

interface Props {
  title?: string
  notices: Notice[]
  disableCollapse?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disableCollapse: false,
})

const isExpanded = ref(false)

const initialNotices = computed(() => {
  if (props.disableCollapse) return props.notices
  return props.notices.slice(0, 5)
})

const animatedNotices = computed(() => {
  if (props.disableCollapse) return []
  return props.notices.slice(5)
})
</script>
